import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, List, Checkbox, Popup, Dropdown, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import { toastr } from 'react-redux-toastr';

class WorkspaceLevelSetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    componentDidMount() {
        let payload = {};
        dispatch.account.getAcountUserWorkspaces(payload)
    }

    enableFullControl = (e, data, workspace) => {
        let message = <div className="confirmMessage">
            <h3>Change Knowledge Bank Preferences</h3>
            <label>{workspace.name}</label>
            {data.checked ?
                <p>Are you sure you want to Allow workspace owner to manage knowledge banks?</p> :
                <p>Are you sure that you want to remove the full control?</p>}
            {data.checked ?
                <span>Workspace owner can manage knowledge banks in the Workspace by performing add/edit/delete operations.</span> :
                <span>Workspace owner will use  knowledge banks that are copied from account to create Content/Playbook/Initiatives.</span>}
        </div>
        toastr.confirm(message, {
            onOk: async () => {
            dispatch.organizationUnit.updateOrganization({ _id: workspace._id, fullControl: data.checked });
            //For Ui Render update
            const updatedOrgList = [...this.props.organizationList.data];
            const updatedOrgIndex = updatedOrgList.findIndex(org => org._id === workspace._id);
            if (updatedOrgIndex !== -1) {
                updatedOrgList[updatedOrgIndex].fullControl = data.checked;
                this.setState({ organizationList: { data: updatedOrgList } });
            }
        }
        });

    }
    render() {
        const { organizationList } = this.props;
        return (
            <div className="general-setting">
                <Card>
                    <Card.Header>
                        Workspaces
                        <div className="float-right">
                            Full Control
                            <Popup
                                flowing
                                hoverable
                                className="popupStyled"
                                inverted
                                position="bottom right"
                                trigger={
                                    <span> <Icon name="exclamation circle" /></span>
                                }
                                content={<React.Fragment>
                                    <strong>What is Full Control?</strong><br />
                                    <p>Workspace Owner can manage Knowledge Banks in the <br />
                                    Workspace by performing add/edit/delete operations.</p>
                                </React.Fragment>}
                            />
                        </div>
                    </Card.Header>
                    <Card.Content className="pad_0">
                        <List divided verticalAlign='middle' >
                            {organizationList && organizationList.data && organizationList.data.filter((a) => a.active === true).map((org, i) => {
                                    let allWSO = org.users &&
                                        org.users.length !== 0 &&
                                        org.users.filter((wso, index) => { return wso.role === "workspaceOwner" });

                                    return <List.Item className="multiLine" key={i}>
                                        <List.Content floated='right'>
                                            {allWSO.filter((i, index) => (index === 0)).map((u, i) => {
                                                return <Popup
                                                    key={i}
                                                    flowing
                                                    hoverable
                                                    className="popupStyled"
                                                    inverted
                                                    position="top right"
                                                    trigger={
                                                        <span
                                                            style={{ position: "absolute", margin: `0 0 0 ${-20 + ((i + 1) * -12)}px` }}>
                                                            <ImageAvater user={u.accountUserId} />
                                                        </span>
                                                    }
                                                    content={u.accountUserId.firstName + " " + u.accountUserId.lastName}
                                                />
                                            })}

                                            {allWSO && allWSO.length > 1 ?

                                                <Popup
                                                    flowing
                                                    hoverable
                                                    className="popupStyled"
                                                    inverted
                                                    position="top right"
                                                    trigger={
                                                        <div className="float-left" style={{ width: "20px", margin: `0 0 0 -44px` }}>
                                                            <span className="memberCountInWSS">
                                                                <span style={{ padding: "0 5px", color: "white" }}>
                                                                    {allWSO.length > 6 ? "+" : null}
                                                                    {allWSO.length > 5 ? 5 : allWSO.length - 1}</span>
                                                            </span>
                                                        </div>
                                                    }
                                                    content={
                                                        <React.Fragment>
                                                            <strong>Workspace Owner</strong>
                                                            <List divided verticalAlign='middle' relaxed='very' style={{ width: "100%" }}   >
                                                                {allWSO && allWSO
                                                                    .filter((wsu, index) => (index !== 0))
                                                                    .map((item, i) => {
                                                                        return <List.Item className="pad_5" key={i}>
                                                                            <ImageAvater user={item.accountUserId} />
                                                                            <List.Content>
                                                                                <List.Header >{item.accountUserId.firstName + " " + item.accountUserId.lastName}</List.Header>
                                                                            </List.Content>
                                                                        </List.Item>
                                                                    })}
                                                            </List>
                                                        </React.Fragment>
                                                    }
                                                />
                                                : null}

                                            <Checkbox toggle
                                                checked={org.fullControl}
                                                onChange={(e, data) => this.enableFullControl(e, data, org)}
                                            />
                                        </List.Content>
                                        <List.Content >
                                            <List.Header >
                                                {org.name}
                                            </List.Header>
                                            {org.fullControl ?
                                                <span>Workspace Owner can manage knowledge banks.</span> :
                                                <span>Workspace Owner can use only knowledge banks copied from account level</span>}
                                        </List.Content>
                                    </List.Item>
                                })}

                        </List>
                    </Card.Content>
                </Card>
            </div>
        );
    }
}

export default withRouter(WorkspaceLevelSetting);